/**
 * Parses a calendar-day string as local noon to keep the calendar day stable across timezones.
 *
 * Accepts either a bare YYYY-MM-DD or an ISO-shaped string whose date portion represents a
 * calendar day (e.g. "2024-03-19T00:00:00.000Z" — common when the backend serializes a
 * date-only field as a UTC-midnight timestamp). Only the date portion is used; any time
 * portion is discarded. The returned Date is anchored at local noon, so date-fns format()
 * renders the same calendar day in any timezone from UTC-11 to UTC+12.
 *
 * Do NOT use this for precise moments (e.g. a transaction timestamp): it discards
 * time-of-day information by design. For real timestamps, use `new Date(value)` directly.
 *
 * @param {string} dateStr - YYYY-MM-DD or an ISO-shaped calendar-day string.
 * @returns {Date}
 */
export function parseDateString(dateStr) {
  const datePart = dateStr.split('T')[0];
  return new Date(`${datePart}T12:00:00`);
}

/**
 * Convert minutes to formatted hour
 *
 * For example:
 * 30 -> 30 min
 * 60 -> 1 hr
 * 90 -> 1.5 hr
 *
 * @param {number} minute
 * @returns {string}
 */
export function formatFromMinuteToFormattedHour(minute) {
  if (minute < 60) {
    return `${minute} min`;
  }

  const hour = minute / 60;
  return `${hour} hr`;
}
